import { ClientLogger } from 'bernie-client';
import { ClientFactories, Store } from 'bernie-plugin-mobx';

import { AppStore } from 'stores';

const stores: ClientFactories = {
  app(): Store {
    return new AppStore({}, ClientLogger.getLoggerWithIdentifier('app.store'), null);
  },
};

export { stores };
